import React from 'react';
import { Modal } from './Modal';
import { Props as ReactModalProps } from 'react-modal';
import clsx from 'clsx';

export interface ModalFormProps extends Omit<ReactModalProps, 'style'> {
  className?: string;
  /**
   * Обработчик клика на кнопку закрытия
   */
  onCloseClick?: () => void;
  /**
   * Заголовок
   */
  title: React.ReactNode;
  /**
   * Открытое состояние
   */
  isOpen: boolean;
  /**
   * Произвольные классы элементов:
   * * title – класс заголовка
   * * content – класс контейнера контента
   * * actions – класс контейнера действий
   */
  classes?: {
    title?: string;
    content?: string;
    actions?: string;
  };
  /**
   * Произвольные стили модального окна
   */
  style?: React.CSSProperties;
  /**
   * Слот действий
   */
  actions?: React.ReactNode;
  /**
   * Слот контента
   */
  children?: React.ReactNode;
}

export function ModalForm({
  isOpen = false,
  title,
  children,
  actions,
  onCloseClick,
  className,
  classes,
  ...props
}: ModalFormProps) {
  return (
    <Modal
      isOpen={isOpen}
      className={clsx('hse-ModalForm', className)}
      onCloseClick={onCloseClick}
      {...props}
    >
      <div className={clsx('hse-ModalForm__title', classes?.title)}>
        {title}
      </div>
      <div className={clsx('hse-ModalForm__content', classes?.content)}>
        {children}
      </div>
      <div className={clsx('hse-ModalForm__actions', classes?.actions)}>
        {actions}
      </div>
    </Modal>
  );
}
